const titles = []

function findClosestRouterViewNode(vnode){
    let parent = vnode.parent
    while(parent){
        if(parent.data.routerView){
            return parent
        }
        parent = parent.parent
    }
    return null
}
function setRouteTitle(el, binding, vnode) {
    const routerViewNode = findClosestRouterViewNode(vnode)
    if (!routerViewNode) {
        throw new Error('v-' + binding.name + '指令只能在路由组件中使用')
    }
    const routerViewDepth = routerViewNode.data.routerViewDepth
    if (titles[routerViewDepth] !== binding.value) {
        titles[routerViewDepth] = binding.value
        document.title = titles.filter(title => title).reverse().join("_")
    }
}
function unsetRouteTitle(el, binding, vnode) {
    const routerViewNode = findClosestRouterViewNode(vnode)
    if (!routerViewNode) {
        return
    }
    const routerViewDepth = routerViewNode.data.routerViewDepth
    if (titles[routerViewDepth]) {
        titles[routerViewDepth] = null
        document.title = titles.filter(title => title).reverse().join("_")
    }
}

export default {
    bind: setRouteTitle,
    update: setRouteTitle,
    unbind: unsetRouteTitle
}
